import { SelectPesquisavel } from '@/ui/components/select-pesquisavel';
import { type CentroCustoResumo } from '@fiscoai/contracts';

import { opcaoDoCentroCusto, useBuscarCentrosCusto } from './api-centro-custo';

interface Props {
  empresaId: string;
  valor: CentroCustoResumo | null;
  aoMudar: (centroCustoId: string | null) => void;
  'aria-label': string;
  placeholder: string;
  className?: string;
  tamanho?: 'md' | 'sm';
  disabled?: boolean;
}

/** Escolha do centro de custo (busca no servidor; só ativos). Limpar devolve ao grupo padrão. */
export function SeletorCentroCusto({ empresaId, valor, aoMudar, ...resto }: Props) {
  const buscar = useBuscarCentrosCusto(empresaId);
  return (
    <SelectPesquisavel
      {...resto}
      rotuloBusca="Buscar centro de custo"
      vazio="Nenhum centro de custo ativo — cadastre na empresa"
      permitirLimpar
      buscar={buscar}
      opcaoSelecionada={valor ? opcaoDoCentroCusto(valor) : null}
      valor={valor?.id ?? null}
      aoMudar={(id) => {
        aoMudar(id);
      }}
    />
  );
}
